import {useMediaQuery} from "react-responsive";

export function useDeviceType() {
    const isMobile = useMediaQuery({query: '(max-width: 375px)'});
    return {
        isMobile,
        isDesktop: !isMobile
    };
}